import React, { useEffect, useState } from 'react';
import UserListSection from './UserListSection/UserListSection';
import UserArchiveSection from './userArchiveSection/UserArchiveSection';
import RoleSettingSection from './roleSettingSection/RoleSettingSection';
import styles from './UserManagement.module.scss';
import { connect } from 'react-redux';
import { getRolesOfAllProjects } from '../../redux/userManagement/actions';

const UserManagement = (props) => {
	const { getRolesOfAllProjects } = props;
	const [section, setSection] = useState('user list');

	useEffect(() => {
		getRolesOfAllProjects();
	}, [])

	return (
		<div className={styles.userManagementWrapper}>
			<div className={styles.title}>User Management</div>
			<hr className={styles.seperator} />

			{section === 'user archive' ? (
				<UserArchiveSection setSection={setSection} />
			) : section === 'role setting' ? (
				<RoleSettingSection setSection={setSection} />
			) : (
				<UserListSection setSection={setSection} />
			)}
		</div>
	);
};

export default connect(null, { getRolesOfAllProjects })(UserManagement);
